<template>
  <div :class="nameclass || 'choiceDefaultClass'">
    <b-row>
      <b-col class="col-xl-7 col-lg-6 col-md-6 col-sm-12 col-12">
        <label for="choices">{{ label || "Select choices" }}</label>
      </b-col>
      <b-col class="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12">
        <b-form-group>
          <b-form-radio-group
            :id="'radio-group-'+ids"
            v-model="selected"
            :options="options"
            v-bind="$attrs"
            v-on="$listeners"
            @input="(event) => {
          $emit('update', event);}"
          ></b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: ["value", "nameclass", "label", "ids"],
  model: {
    prop: "value",
    event: "update"
  },
  data() {
    return {
      selected: this.value,
      options: [
        { text: "Yes", value: true },
        { text: "No", value: false }
      ]
    };
  },
  watch: {
    value: function(updated, old) {
      this.selected = updated;
    }
  }
};
</script>